import React from "react";
import Container from "react-bootstrap/Container";
import {Breadcrumb, Col, Row} from "react-bootstrap";
import photo1 from "../img/pf2026/pf2026_1.jpeg";
import photo2 from "../img/pf2026/pf2026_2.jpeg";
// import photo3 from "../img/pf2026/pf2026_3.jpeg";
import photo4 from "../img/pf2026/pf2026_4.jpeg";
import photo5 from "../img/pf2026/pf2026_5.jpeg";

const PastPF2026 = () => {
    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Porchfest 2026</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <div>
                            Winchester Porchfest 2026 was held on Saturday June 13. Here are some
                            of the moments from that day.
                        </div>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <div className="ratio ratio-16x9">
                            <iframe src="https://www.youtube.com/embed/RUxpFHPbE0o"
                                    title="Porchfest 2026 Highlights"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen/>
                        </div>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <div className="ratio ratio-16x9">
                            <iframe src="https://www.youtube.com/embed/Pdaq533R19U"
                                    title="Porchfest 2026"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen/>
                        </div>
                    </Col>
                </Row>
                <Row className="mb-3 g-3">
                    <Col xs={12} sm={6}>
                        <img src={photo2} alt="Porchfest 2026" className="img-fluid rounded"/>
                    </Col>
                    <Col xs={12} sm={6}>
                        <img src={photo4} alt="Porchfest 2026" className="img-fluid rounded"/>
                    </Col>
                </Row>
                <Row className="mb-3 g-3">
                    <Col xs={12} md={8}>
                        <img src={photo1} alt="Porchfest 2026" className="img-fluid rounded"/>
                    </Col>
                    <Col xs={12} md={4}>
                        <img src={photo5} alt="Porchfest 2026" className="img-fluid rounded"/>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default PastPF2026;
